// App.js
// <!-- by Majed Developer Solution © 2025 -->

import React from 'react';
import './App.css';

import SearchBar        from './components/SearchBar';
import AdvancedFilters  from './components/AdvancedFilters';
import ResultsList      from './components/ResultsList';
import WhatsappSender   from './components/WhatsappSender';

function App() {

  // =========================
  // LOGIN CONTROL
  // =========================
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [remember, setRemember] = React.useState(false);
  const [showPass, setShowPass] = React.useState(false);

  const LOGIN_EMAIL = "sender@gulfccs.com";
  const LOGIN_PASS  = "Gulfccs@2026";

  React.useEffect(() => {
    const saved = localStorage.getItem("loggedIn");
    if (saved === "true") {
      setLoggedIn(true);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("loggedIn");
    setLoggedIn(false);
  };

  // =========================
  // APP STATES
  // =========================
  const [query, setQuery]         = React.useState('');
  const [filters, setFilters]     = React.useState({});
  const [results, setResults]     = React.useState([]);
  const [selectedPlace, setPlace] = React.useState(null);
  const [loading, setLoading]     = React.useState(false);
  const [error, setError]         = React.useState('');
  const [visibleCount, setVisibleCount] = React.useState(10);


  const doSearch = async () => {
    setLoading(true);
    setError('');

    const params = new URLSearchParams({
      q: query,
      city: filters.city || '',
      area: filters.area || ''
    });

    try {
      const resp  = await fetch(`/api/search?${params}`);
      const data  = await resp.json();

      setResults(data.results || []);
      setPlace(null);
      setVisibleCount(10);

    } catch (e) {
      setError('Search error / خطأ في البحث');
    } finally {
      setLoading(false);
    }
  };


  const onSelectPlace = async (placeId) => {
    setLoading(true);
    setError('');

    try {
      const resp = await fetch(
        `/api/details?place_id=${encodeURIComponent(placeId)}`
      );
      const json = await resp.json();
      setPlace(json.place);
    } catch (e) {
      setError('Details error / خطأ في التحميل');
    } finally {
      setLoading(false);
    }
  };


  // =========================
  // LOGIN PAGE
  // =========================
  if (!loggedIn) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#ece5dd",
          flexDirection: "column",
          padding: "20px"
        }}
      >

        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="logo"
          style={{ height: 120, marginBottom: 15 }}
        />

        <h2
          style={{
            marginBottom: 5,
            fontWeight: "bold",
            color: "#075e54"
          }}
        >
          Info Hub – Best Yet
        </h2>

        <h6
          style={{
            marginTop: 0,
            marginBottom: 25,
            color: "#555"
          }}
        >
          مركز المعلومات – الأفضل حتى الآن
        </h6>

        <div
          style={{
            background: "#fff",
            padding: "30px",
            width: "350px",
            maxWidth: "92%",
            borderRadius: "20px",
            boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
            textAlign: "center"
          }}
        >

          <h3 className="mb-3">Login / تسجيل الدخول</h3>

          <input
            id="loginEmail"
            type="email"
            placeholder="Email"
            className="form-control mb-3"
            style={{ borderRadius: 16 }}
          />

          <div style={{ position: "relative" }}>

            <input
              id="loginPass"
              type={showPass ? "text" : "password"}
              placeholder="Password"
              className="form-control mb-3"
              style={{ borderRadius: 16, paddingRight: 40 }}
            />

            <span
              onClick={() => setShowPass(!showPass)}
              style={{
                position: "absolute",
                right: 12,
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#075e54",
                fontWeight: "bold",
                fontSize: 18
              }}
            >
              👁
            </span>

          </div>

          <div style={{ textAlign: "left", marginBottom: 15 }}>
            <label style={{ cursor: "pointer" }}>
              <input
                type="checkbox"
                onChange={(e) => setRemember(e.target.checked)}
                style={{ marginRight: 6 }}
              />
              Remember me / تذكرني
            </label>
          </div>

          <button
            className="btn btn-success w-100"
            style={{ borderRadius: 16 }}
            onClick={() => {
              const email = document.getElementById("loginEmail").value;
              const pass  = document.getElementById("loginPass").value;

              if (email === LOGIN_EMAIL && pass === LOGIN_PASS) {

                if (remember) {
                  localStorage.setItem("loggedIn", "true");
                }

                setLoggedIn(true);

              } else {
                alert("Wrong Email or Password");
              }
            }}
          >
            Login / دخول
          </button>

        </div>

        <p
          style={{
            marginTop: 20,
            fontSize: 12,
            color: "#075e54",
            fontWeight: "bold",
            textAlign: "center"
          }}
        >
          Majed Group Developer Solution © 2025
        </p>

      </div>
    );
  }


  // =========================
  // MAIN APP
  // =========================
  return (
    <div className="app-shell container">

      <header className="text-center mb-4">
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="Logo"
          style={{
            height: "140px",
            width: "auto",
            marginBottom: "10px"
          }}
        />

        <h2 className="fw-bold">Info Hub – Best Yet</h2>
        <h6 className="text-secondary">
          مركز المعلومات – الأفضل حتى الآن
        </h6>
      </header>

      <div className="mb-4">
        <SearchBar
          value={query}
          onChange={setQuery}
          onSearch={doSearch}
          placeholder="Search… / ابحث…"
        />

        <AdvancedFilters
          filters={filters}
          onChange={setFilters}
        />
      </div>

      {loading && (
        <p className="text-center mt-3">
          Loading… / جاري التحميل…
        </p>
      )}

      {error && (
        <p className="text-danger text-center mt-3">
          {error}
        </p>
      )}

      <ResultsList
        results={results.slice(0, visibleCount)}
        onSelect={onSelectPlace}
      />

      {results.length > visibleCount && (
        <div className="text-center mt-3">
          <button
            className="btn btn-success"
            onClick={() => setVisibleCount(visibleCount + 10)}
          >
            Load More / عرض المزيد
          </button>
        </div>
      )}

      {selectedPlace && (
        <div className="mt-4">
          <WhatsappSender
            place={selectedPlace}
            onClose={() => setPlace(null)}
          />
        </div>
      )}

      <footer
        className="text-center text-secondary mt-5 mb-2"
        style={{ fontSize: 13 }}
      >
        <button
          onClick={handleLogout}
          style={{
            background: "#d9534f",
            border: "none",
            padding: "5px 18px",
            borderRadius: "15px",
            color: "#fff",
            marginBottom: "6px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold"
          }}
        >
          Logout / تسجيل خروج
        </button>
        <br/>
        Majed Group Developer Solution © 2025
      </footer>

    </div>
  );
}

export default App;